import styled from "@emotion/styled";

const BREAKPOINT_MOBILE = "768px";

export const BotaoFlutuante = styled.button`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 90;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  border-radius: 99px;
  cursor: pointer;

  background-color: ${(props) => props.theme.cores.surface4};
  box-shadow: 0px 4px 8px rgba(135, 135, 135, 0.15);
  transition: box-shadow 0.2s ease-in-out;

  img {
    display: block;
    width: 25px;
    height: 25px;
    margin: -5px 0 0 1px;
  }

  &:hover {
    box-shadow: 0px 4px 12px rgba(35, 160, 232, 0.4);
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.cores.actionActive};
    outline-offset: 2px;
  }

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    right: 16px;
    bottom: 86px;
  }
`;

export const Painel = styled.section`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 95;
  display: flex;
  flex-direction: column;
  width: 293px;
  --altura-painel: min(585px, calc(100vh - 48px));
  height: var(--altura-painel);
  overflow: hidden;

  border-radius: 8px;
  background-color: ${(props) => props.theme.cores.surface2};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  font-family: "Source Sans Pro", sans-serif;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    right: 8px;
    left: 8px;
    bottom: 78px;
    width: auto;
    --altura-painel: min(585px, calc(100vh - 190px));
  }
`;

export const Cabecalho = styled.header`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 8px;
  background-color: ${(props) => props.theme.cores.surface4};
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(props) => props.$tamanho}px;
  height: ${(props) => props.$tamanho}px;
  border-radius: 49.5px;
  background-color: ${(props) =>
    props.$destaque ? props.theme.cores.bgCheckBoxContainer : props.theme.cores.surface4};

  img {
    display: block;
    width: 12.5px;
    height: 12.5px;
    margin: -2.5px 0 0 0.5px;
  }
`;

export const NomeAssistente = styled.h2`
  flex: 1;
  min-width: 0;
  margin: 0;
  font-family: Comfortaa, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.15px;
  color: ${(props) => props.theme.adaptativo("neutral20", "neutral70")};
`;

export const BotaoIcone = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: ${(props) => props.theme.cores.actionActive};

  svg {
    font-size: 20px;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.cores.actionActive};
  }
`;

export const Mensagens = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
  padding: 12px 15px;
  overflow-y: auto;
`;

export const Aviso = styled.p`
  margin: 0;
  padding: 0 4px;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0.25px;
  color: ${(props) => props.theme.adaptativo("neutral20", "neutral70")};
`;

export const LinhaMensagem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;
  align-self: ${(props) => (props.$usuario ? "flex-end" : "flex-start")};
  max-width: ${(props) => (props.$usuario ? "212px" : "100%")};
  margin-left: ${(props) => (props.$usuario ? "29px" : "0")};
`;

export const Balao = styled.div`
  padding: 8px;
  border-radius: 4px;
  font-size: 15px;
  letter-spacing: 0.25px;
  overflow-wrap: anywhere;
  white-space: ${(props) => (props.$html ? "normal" : "pre-wrap")};
  color: ${(props) => props.theme.cores.textoSimples};
  background-color: ${(props) =>
    props.$usuario
      ? props.theme.adaptativo("brand10", "brand60")
      : props.theme.cores.neutral99};

  p,
  ul,
  ol {
    margin: 0 0 8px;
  }

  p:last-child,
  ul:last-child,
  ol:last-child {
    margin-bottom: 0;
  }

  ul,
  ol {
    padding-left: 20px;
  }

  a {
    color: ${(props) => props.theme.cores.actionActive};
    text-decoration: underline;
  }

  img {
    max-width: 100%;
  }

  pre,
  code {
    font-size: 13px;
    white-space: pre-wrap;
  }
`;

export const Digitando = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  letter-spacing: 0.25px;
  color: ${(props) => props.theme.adaptativo("neutral20", "neutral70")};
`;

export const MensagemErro = styled.p`
  margin: 0;
  padding: 8px;
  border-radius: 4px;
  font-size: 13px;
  letter-spacing: 0.25px;
  color: ${(props) => props.theme.cores.semanticDanger2};
  background-color: ${(props) => props.theme.cores.semanticDanger3};
`;

export const Rodape = styled.footer`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
  padding: 8px 16px 16px;
`;

export const CampoMensagem = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  padding: 8px;
  border-radius: 8px;
  background-color: ${(props) => props.theme.cores.neutral99};
  box-shadow: 0px 2px 8px rgba(175, 175, 175, 0.25);
`;

export const AreaTexto = styled.textarea`
  flex: 1;
  min-width: 0;
  /* O topo da caixa para no meio do painel: desconta o padding da caixa (16px) e do rodapé (16px). */
  max-height: calc(var(--altura-painel) / 2 - 32px);
  min-height: 24px;
  overflow-y: auto;
  padding: 3px 0;
  border: none;
  outline: none;
  resize: none;
  background: transparent;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.25px;
  color: ${(props) => props.theme.cores.textoSimples};

  &::placeholder {
    color: ${(props) => props.theme.cores.neutral60};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const BotaoEnviar = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: ${(props) => props.theme.cores.actionActive};
  background-color: ${(props) => props.theme.adaptativo("brand10", "brand60")};

  svg {
    font-size: 16px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.cores.actionActive};
  }
`;

export const EstadoVazio = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 0 19px;
  text-align: center;
`;

export const Apresentacao = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.adaptativo("neutral10", "neutral90")};

  strong {
    display: block;
    margin-bottom: 4px;
  }
`;

export const LinkSuporte = styled.a`
  color: ${(props) => props.theme.cores.actionActive};
  font-weight: 600;
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.cores.actionActive};
    outline-offset: 2px;
  }
`;

const BotaoLargo = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  padding: 8px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 2px 8px rgba(175, 175, 175, 0.25);
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.25px;

  img {
    display: block;
    width: 20px;
    height: 20px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.cores.actionActive};
    outline-offset: 2px;
  }
`;

export const BotaoIniciar = styled(BotaoLargo)`
  color: ${(props) => props.theme.cores.neutral100};
  background-color: ${(props) => props.theme.cores.surfaceActionActivePrimary};
`;

export const BotaoFinalizar = styled(BotaoLargo)`
  color: ${(props) => props.theme.cores.actionActive};
  background-color: ${(props) => props.theme.cores.bgCheckBoxContainer};
`;

export const BlocoPesquisa = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OpcoesResolvido = styled.div`
  display: flex;
  gap: 4px;
`;

export const BotaoOpcao = styled.button`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 0;
  border: 1px solid ${(props) => props.theme.cores.bgCheckBoxContainer};
  border-radius: 8px;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: ${(props) =>
    props.$selecionado ? props.theme.cores.neutral100 : props.theme.cores.actionActive};
  background-color: ${(props) =>
    props.$selecionado ? props.theme.cores.surfaceActionActivePrimary : props.theme.cores.neutral99};

  svg {
    font-size: 20px;
  }

  &:disabled {
    cursor: default;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.cores.actionActive};
  }
`;

export const Notas = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const BotaoNota = styled.button`
  width: 30px;
  height: 32px;
  padding: 0;
  border: 1px solid ${(props) => props.theme.cores.bgCheckBoxContainer};
  border-radius: 8px;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: ${(props) => (props.$selecionado ? 700 : 400)};
  letter-spacing: 0.5px;
  color: ${(props) =>
    props.$selecionado ? props.theme.cores.neutral100 : props.theme.cores.textoSimples};
  background-color: ${(props) =>
    props.$selecionado ? props.theme.cores.surfaceActionActivePrimary : props.theme.cores.neutral99};

  &:disabled {
    cursor: default;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.cores.actionActive};
  }
`;
